import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #dadada;
  border-radius: 3px;
  padding: 15px;
  width: 512px;
  margin: 24px 0;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const Input = styled.input`
  border: none;
  background: transparent;
  outline: none !important;
  color: #828282;
  margin-left: 8px;
  font-size: 14px;
  width: calc(100% - 30px);
`;
